import { Magic } from 'magic-sdk';

class MagicClientBase {
    constructor(props) {
        this.magicClients = {};
        this.extensions = [];
        this.apiKey = props.apiKey;
    }
    createClient(config) {
        return new Magic(this.apiKey, Object.assign(Object.assign({}, config), { extensions: [
                ...this.extensions,
                ...((config === null || config === void 0 ? void 0 : config.extensions) && Array.isArray(config === null || config === void 0 ? void 0 : config.extensions)
                    ? config.extensions
                    : []),
            ] }));
    }
    getClient() {
        if (this.magicClients.default) {
            return this.magicClients.default;
        }
        const config = this.getClientConfig();
        this.magicClients.default = this.createClient(config);
        return this.magicClients.default;
    }
    use(extension) {
        this.extensions.push(extension);
        // Clear all existing clients
        Object.keys(this.magicClients).forEach((key) => {
            delete this.magicClients[key];
        });
    }
}

export { MagicClientBase };
